import React from 'react';
import {
  Route,
  Redirect
} from 'react-router-dom'
import {isSignedIn} from './Auth'

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (  
    <Route
      {...rest}
      render={props =>
        isSignedIn() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )};


// WEBPACK FOOTER //
// ./src/PrivateRoute.js